import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTransactions } from '../../features/transaction/transactionSlice';
import ModalForm from '../modalForm/ModalForm';
import Pagination from '../ui/Pagination';
import Header from './Header';
import SingleTransaction from './SingleTransaction';
export default function Transactions() {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const { transactions, isLoading, isError, transactionPerPage } = useSelector(
    (state) => state.transaction
  );
  const { search, type } = useSelector((state) => state.filters);

  useEffect(() => {
    dispatch(fetchTransactions());
  }, [dispatch]);

  const indexOfLastTransaction = currentPage * transactionPerPage;
  const indexOfFirstTransaction = indexOfLastTransaction - transactionPerPage;
  const currentTransactions = transactions.slice(
    indexOfFirstTransaction,
    indexOfLastTransaction
  );

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  //   const filterBySearch = (transactions) => {
  //     if (search.length > 0) {
  //       return search.includes(transactions?.title);
  //     } else return transactions;
  //   };

  // decide what to render
  let content = null;
  if (isLoading) content = <p>Loading...</p>;

  if (!isLoading && isError)
    content = <p className="error">There was an error occured</p>;

  if (!isLoading && !isError && transactions?.length > 0) {
    content = currentTransactions
      .filter((value) => {
        if (search == '') {
          console.log(value.name);
          return value;
        } else if (value.name.toLowerCase().includes(search.toLowerCase())) {
          return value;
        }
      })
      .filter((v) => {
        if (type == '') {
          return v;
        } else if (v.type.toLowerCase().includes(type.toLowerCase())) {
          return v;
        }
      })
      .map((transaction) => (
        <SingleTransaction
          openModal={setOpenModal}
          key={transaction.id}
          transaction={transaction}
        />
      ));
  }

  if (!isLoading && !isError && transactions?.length === 0) {
    content = <p>No transactions found!</p>;
  }

  return (
    <>
      <Header />
      {openModal && <ModalForm closeModal={setOpenModal} />}
      <div className="allTransactions">
        <div>
          <div className="conatiner_of_list_of_transactions">
            <ul>{content}</ul>
          </div>
        </div>
      </div>
      <Pagination paginate={paginate} />
    </>
  );
}
